import { render, staticRenderFns } from "./MaterialCart.vue?vue&type=template&id=c7e9638e"
import script from "./MaterialCart.vue?vue&type=script&lang=js"
export * from "./MaterialCart.vue?vue&type=script&lang=js"
import style0 from "./MaterialCart.vue?vue&type=style&index=0&id=c7e9638e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports